const initialState=[]
export const GroupsReducer = (state = initialState,action)=>{
    switch(action.type){
        case 'UPDATE_GROUPS':
            return action.payload
        default:
            return state
    }
}